import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://india-crafts-backend.onrender.com/api'
    : 'http://localhost:5000/api');

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
apiClient.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const adminToken = sessionStorage.getItem('adminToken');
      const userToken = localStorage.getItem('authToken');
      const sellerToken = localStorage.getItem('sellerToken');

      const isSellerRequest =
        typeof config.url === 'string' && config.url.startsWith('/seller');
      const isAdminRequest =
        typeof config.url === 'string' && config.url.startsWith('/admin');

      let token;
      if (isSellerRequest) {
        token = sellerToken || adminToken || userToken;
      } else if (isAdminRequest) {
        token = adminToken || userToken || sellerToken;
      } else {
        token = userToken || adminToken || sellerToken;
      }

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      const adminToken = sessionStorage.getItem('adminToken');
      const userToken = localStorage.getItem('authToken');

      if (adminToken) {
        sessionStorage.removeItem('adminToken');
        sessionStorage.removeItem('adminEmail');
        window.location.href = '/admin/login';
      } else if (userToken) {
        localStorage.removeItem('authToken');
        window.location.href = '/account';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
